import React, { FunctionComponent } from 'react';
import { Alert } from '@mui/material';

import SettingsPanelBase from '../SettingsPanelBase';
import { SettingsCloseButton } from './SettingsCloseButton';

const ErrorPanel: FunctionComponent<{ error: string }> = (props) => (
  <SettingsPanelBase saveButtons={<SettingsCloseButton />}>
    <Alert variant="outlined" severity="error" sx={{ marginX: 2, textWrap: 'wrap' }}>
      {props.error}. Please reload the settings panel or contact Paragon Customer Support.
    </Alert>
  </SettingsPanelBase>
);

export default ErrorPanel;
